import React from "react";
import moment from "moment";
import { Button } from "@progress/kendo-react-buttons";
import { Field } from "@progress/kendo-react-form";
import { get } from "../../redux/actions/checklistTemplateActions";
import { Input } from "@progress/kendo-react-inputs";
import { InputText } from "../../components/Input";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Switch } from "@material-ui/core";
import {
  get as getGroup,
  insert as insertGroup,
} from "../../redux/actions/groupActions";
import { getSpChkInstruments, getSpChkTemp } from "../../services/InstDService";
import { getSpChkInstList } from "../../redux/actions/instDActions";
import { connect } from "react-redux";

class SpotCheck extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.intCallBack = null;
    this.state = {
      showSpotCheck: false,
      serialNumbers: [],
      serialNumber: null,
      lsl: null,
      target: null,
      usl: null,
      type: null,
      temperature: null,
      switchStatus: false,
      switchOn: false,
      action: null,
      status: 0,
    };
    this.switchToggle = this.switchToggle.bind(this);
    this.startTempCallBack = this.startTempCallBack.bind(this);
    this.stopTempCallBack = this.stopTempCallBack.bind(this);
  }

  getActualTemperature = () => {
    if (this.props.isEditMode) {
      return this.props.task.checklistTask.value;
    }
    return 0.0;
  };

  componentDidMount() {
    let taskTemplate = this.props.task.taskTemplate;
    let parameters = JSON.parse(taskTemplate.parameters);
    let temperature = null;
    let action = null;
    let status = 0;
    if (this.props.task.checklistTask) {
      let jsonValue = this.props.task.checklistTask.jsonValue;
      if (jsonValue) {
        let json;
        try {
          json = JSON.parse(jsonValue);
          temperature = json.temperature;
          action = json.action;
          status = json.status;
        } catch (err) {
          console.log('Bad json:', jsonValue);
          debugger;
        }
      }
    };

    if (parameters != null) {
      this.setState({
        lsl: parameters.lsl,
        target: parameters.target,
        usl: parameters.usl,
        type: parameters.type,
        temperature: temperature,
        action: action,
        status: status,
      });
    };

    let editSpotCheckPollWorker = () => {
      if (this.props.task?.checklistTask?.sequence === 0) {
        this.editSpotCheck();        
      } else {
        setTimeout(editSpotCheckPollWorker, 1000);
      }
    };
    setTimeout(editSpotCheckPollWorker, 50);

    const openChecklistMatch = window.location
      .search.match(/[?&]openchecklist=([^&]+)/);
    const openChecklist = openChecklistMatch?.[1] 
      ? decodeURIComponent(openChecklistMatch?.[1])
      : null;

    getSpChkInstruments(this.props.task.taskTemplate.enterpriseId)
    .then((response) => {
      const serialNumbers = response.data;
      // fix in progress
      this.setState({
        serialNumbers
      });
    });

    this.props.getSpChkInstList(this.props.task.taskTemplate.enterpriseId);
    let interval = setInterval(() => {
      if (this.props.pending)
        return;
      
      if (this.props.serialNumbers?.length > 0) {
        const oldOn = this.state.switchOn;
        this.setState({
          serialNumbers: this.props.serialNumbers,
          serialNumber: this.props.serialNumbers[0],
          switchStatus: true,
          switchOn: this.props.initiallyOn || false,
          //temperature: this.getActualTemperature(),
        }, () => {
          if (!oldOn && this.state.switchOn) {
            this.startTempCallBack();
          }
        });
      }

      clearInterval(interval);
    }, 300);
  }

  componentWillUnmount() {
    console.log('componentWillUnmount: stopping temp callback');
    this.stopTempCallBack();
    this.intCallBack = null;
  }

  setTemperature = (val) => {
    var id = "temperature_" + this.props.sequence;
    var element = document.getElementById(id);
    var nativeInputValueSetter = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype, "value").set;
    nativeInputValueSetter.call(element, val);
    var event = new Event('input', { bubbles: true });
    element.dispatchEvent(event);
  };

  startTempCallBack() {
    let worker = () => {
      getSpChkTemp(this.state.serialNumber)
        .then((response) => {
          console.log('Success getting spotcheck temperature');
          let temperature = response.data.toString();
          let status = 0;
          if (!isNaN(temperature)) {
            if (!temperature || this.state.lsl == null || this.state.usl == null) {
              status = 0;
            }
            else {
              status = (parseFloat(temperature) >= this.state.lsl && 
                parseFloat(temperature) <= this.state.usl) ? 2 : 1;
            }
            this.setTemperature(temperature);
            this.setState({
              temperature: temperature,
              status: status,
            });
            this.doChange(this.props.templateName, this.props.sequence, this.state.lsl, 
              this.state.target, this.state.usl, this.state.type.name, 
              temperature, status, this.state.action);
          }
        })
        .catch((error) => {
          console.log('Error getting spotcheck temperature');
        })
        .finally(() => {
          if (this.intCallBack)
            this.intCallBack = setTimeout(worker, 1000);
        });
    };
    
    this.intCallBack = setTimeout(worker, 1000);
  }

  stopTempCallBack() {
    if (this.intCallBack) {
      clearTimeout(this.intCallBack);
      this.intCallBack = null;
    }
  }

  switchToggle = (event) => {
    this.setState((prevState) => {
      return {
        switchOn: !prevState.switchOn,
      };
    }, () => {
      if (this.state.switchOn) {
        this.startTempCallBack();
      } else {
        this.stopTempCallBack();
      }
    });
  };

  dropDownChange = (event) => {
    this.setState({
      serialNumber: event.target.value,
    });
    setTimeout(() => { }, 500);
  };

  editSpotCheck = (event) => {
    let status = this.state.showSpotCheck;
    this.setState({
      showSpotCheck: !status,
    });
  };

  doChange = (templatename, sequence, lsl, target, usl, type, temperature, status, action) => {
    let obj = {
      lsl,
      target,
      usl,
      type,
      temperature: temperature,
      action: action,
      status: status,
    };

    let date = new Date();
    let strDate = moment(date).format("YYYY-MM-DDTHH:mm:ss.000");
    let o = {
      templateName: templatename,
      sequence: sequence,
      jsonValue: JSON.stringify(obj),
      dateCompleted: temperature == null ? null : strDate,
    };
    this.props.onChange(o);
  };

  temperatureChange = (event) => {
    let temperature = event.target.value;
    let status = 0;
    if (!isNaN(temperature)) {
      if (temperature == "" || this.state.lsl == null || this.state.usl == null) {
        status = 0;
      }
      else {
        status = (parseFloat(temperature) >= this.state.lsl &&
          parseFloat(temperature) <= this.state.usl) ? 2 : 1;
      }
      this.setState({
        temperature: temperature,
        status: status,
      });
      this.doChange(this.props.templateName,
        this.props.sequence, this.state.lsl,
        this.state.target, this.state.usl,
        this.state.type.name, temperature,
        status, this.state.action);
    }
  };

  actionChange = (event) => {
    let action = event.target.value;
    this.setState({
      action: action,
    });
    this.doChange(this.props.templateName, 
      this.props.sequence, this.state.lsl, 
      this.state.target, this.state.usl, 
      this.state.type.name, this.state.temperature,
      this.state.status, action);
  };

  render() {
    let sequence = this.props.sequence.toString()
    // Prevent humans typing in a number, only accept from probe
    const disableTemperatureTypeIn = true;
    let panel = (
      <>
        <tr className={"k-master-row"}>
          <td
            style={{
              verticalAlign: "top",
              paddingLeft: 5,
            }}
          >
            {this.props.task.taskTemplate.name}
          </td>
          <td
            style={{
              verticalAlign: "top",
              paddingLeft: 5,
            }}
          >
            {this.props.task.taskTemplate.description}
          </td>
          <td
            style={{
              verticalAlign: "top",
              textAlign: "right",
              paddingLeft: 5,
            }}
          >
            <Button
              type="button"
              // id={"Edit" + this.props.sequence}
              style={{
                width: "28px",
                height: "28px",
                borderRadius: "25% 25%",
                marginTop: "2px",
                marginBottom: "2px",
              }}
              className="buttons-container-button"
              icon="edit"
              disabled={this.props.isDeleteMode}
              onClick={this.editSpotCheck}
            />
          </td>
        </tr>
        {this.state.showSpotCheck.toString() === "true" && (
          <tr
            // id={"spotCheck_" + sequence}
            className={"k-master-row"}
          >
            <td colSpan="2" align={"left"}>
              <table
                border="0"
                cellPadding={"0"}
                cellSpacing={"0"}
                width={"100%"}
              >
                <tbody>
                  <tr>
                    <td width={"25%"} align="center">
                      <label>
                        <b>LSL</b>
                      </label>
                    </td>
                    <td width={"25%"} align="center">
                      <label>
                        <b>Target</b>
                      </label>
                    </td>
                    <td width={"25%"} align="center">
                      <label>
                        <b>USL</b>
                      </label>
                    </td>
                    <td width={"25%"} align="center">
                      <label>
                        <b>Type</b>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td width={"25%"} align="left">
                      <input
                        type="input"
                        readOnly={true}
                        key={"lsl_" + sequence}
                        // id={"lsl_" + sequence}
                        name={"lsl_" + sequence}
                        value={this.state.lsl}
                        style={{
                          width: "90%",
                          lineHeight: "32px",
                          textAlign: "center",
                          marginBottom: "10px",
                          marginTop: "10px",
                        }}
                      />
                    </td>
                    <td width={"25%"} align="left">
                      <input
                        type="input"
                        key={"target_" + sequence}
                        // id={"target_" + sequence}
                        name={"target_" + sequence}
                        value={this.state.target}
                        readOnly={true}
                        style={{
                          width: "90%",
                          lineHeight: "32px",
                          textAlign: "center",
                          marginBottom: "10px",
                          marginTop: "10px",
                        }}
                      />
                    </td>
                    <td width={"25%"} align="left">
                      <input
                        type="input"
                        key={"usl_" + sequence}
                        // id={"usl_" + sequence}
                        name={"usl_" + sequence}
                        value={this.state.usl}
                        readOnly={true}
                        style={{
                          width: "90%",
                          lineHeight: "32px",
                          textAlign: "center",
                          marginBottom: "10px",
                          marginTop: "10px",
                        }}
                      />
                    </td>
                    <td width={"25%"}>
                      <input
                        type="input"
                        key={"type_" + sequence}
                        // id={"type_" + sequence}
                        name={"type_" + sequence}
                        defaultValue={this.state.type.name}
                        readOnly={true}
                        style={{
                          textAlign: "center",
                          width: "90%",
                          lineHeight: "32px",
                          marginBottom: "10px",
                          marginTop: "10px",
                        }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td align="center">
                      <label>
                        <b>Actual °C</b>
                      </label>
                    </td>
                    <td align="center">
                      <label>
                        <b>Serial No.</b>
                      </label>
                    </td>
                    <td colSpan={"2"}>
                      <table
                        border={"0"}
                        cellPadding={"0"}
                        cellSpacing={"0"}
                        width={"100%"}>
                        <td align="center" width="25%">
                          {this.state.switchOn
                            ? <b>on</b>
                            : <b>off</b>
                          }
                        </td>
                        <td align="center" width="25%">
                          <label>
                            <b>P/F</b>
                          </label>
                        </td>
                        <td width="50%" align="center">
                          <label>
                            <b>Corrective Action</b>
                          </label>
                        </td>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td align="left">
                      <Field
                        ref={this.myRef}
                        key={"temperature_" + sequence}
                        type={"text"}
                        id={"temperature_" + sequence}
                        name={"temperature_" + sequence}
                        component={InputText}
                        defaultValue={this.state.temperature}
                        onChange={this.temperatureChange}
                        disabled={disableTemperatureTypeIn}
                        style={{
                          width: "90%",
                          lineHeight: "32px",
                          textAlign: "center",
                          marginBottom: "10px",
                          marginTop: "10px",
                        }}
                      />{" "}
                    </td>
                    <td align="left">
                      <Field
                        style={{ width: "90%", float: "left" }}
                        component={DropDownList}
                        defaultValue={
                          this.state.serialNumbers.length == 0
                            ? undefined
                            : this.state.serialNumbers[0]
                        }
                        onChange={this.dropDownChange}
                        data={this.state.serialNumbers}
                      />{" "}
                    </td>
                    <td colSpan={"2"}>
                      <table
                        border={"0"}
                        cellPadding={"0"}
                        cellSpacing={"0"}
                        width={"100%"}>
                        <tbody>
                          <tr>
                            <td align="center" valign="middle" width="25%">
                              <Field
                                name="switchOn"
                                // component={Switch}
                                component={(fieldProps) => {
                                  return <Switch
                                    checked={this.state.switchOn}
                                    disabled={!this.state.switchStatus}
                                    onChange={(e) => {
                                      fieldProps.onChange?.({
                                        value: e.target.checked
                                      });
                                    }}
                                  />;
                                }}
                                onChange={this.switchToggle}
                              />
                            </td>
                            <td align="center" width="25%">
                              {this.state.status === 0 && (
                                <div
                                  style={{
                                    position: "relative",
                                    marginTop: "2px",
                                    width: "80px",
                                    height: "36px",
                                    border: "solid 2px #000000",
                                    borderRadius: "5px 5px 5px 5px",
                                    WebkitBorderRadius: "5px 5px 5px 5px",
                                    MozBorderRadius: "5px 5px 5px 5px"
                                  }}
                                >
                                  <span
                                    style={{
                                      position: "absolute",
                                      top: "5px",
                                      left: "20px",
                                      color: "#000000"
                                    }}
                                  ><b>&nbsp;</b></span>
                                </div>
                              )}
                              {this.state.status == 1 && (
                                <div
                                  style={{
                                    position: "relative",
                                    marginTop: "2px",
                                    width: "80px",
                                    height: "36px",
                                    backgroundColor: "#ff6347",
                                    border: "solid 2px #000000",
                                    borderRadius: "5px 5px 5px 5px",
                                    WebkitBorderRadius: "5px 5px 5px 5px",
                                    MozBorderRadius: "5px 5px 5px 5px"
                                  }}
                                >
                                  <span
                                    style={{
                                      position: "absolute",
                                      top: "5px",
                                      left: "20px",
                                      color: "#ffffff"
                                    }}
                                  ><b>FAIL</b></span>
                                </div>
                              )}
                              {this.state.status == 2 && (
                                <div
                                  style={{
                                    position: "relative",
                                    marginTop: "2px",
                                    width: "80px",
                                    height: "36px",
                                    backgroundColor: "#009900",
                                    border: "solid 2px #000000",
                                    borderRadius: "5px 5px 5px 5px",
                                    WebkitBorderRadius: "5px 5px 5px 5px",
                                    MozBorderRadius: "5px 5px 5px 5px"
                                  }}
                                >
                                  <span
                                    style={{
                                      position: "absolute",
                                      top: "5px",
                                      left: "20px",
                                      color: "#ffffff"
                                    }}
                                  ><b>PASS</b></span>
                                </div>
                              )}
                            </td>
                            <td width="50%" valign="middle">
                              <Field
                                key={"action_" + sequence}
                                // id={"action_" + sequence}
                                name={"action_" + sequence}
                                component={Input}
                                defaultValue={this.state.action}
                                onChange={this.actionChange}
                                style={{
                                  textAlign: "center",
                                  width: "90%",
                                  lineHeight: "32px",
                                  margin: "0px",
                                  padding: "0px"
                                }}
                              />{" "}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td>&nbsp;</td>
          </tr>
        )}
      </>
    );
    return <React.Fragment>{panel}</React.Fragment>;
  }
}

const mapStateToProps = (state) => {
  return {
    serialNumbers: state.instDReducer.serialNumbers,
    pending: state.instDReducer.pending,
  };
};

const mapDispatchToProps = {
  get,
  getGroup,
  insertGroup,
  getSpChkInstList,
};

export default connect(mapStateToProps, mapDispatchToProps)(SpotCheck);

// export const NewSpotCheck = ({
//   openChecklistId,
//   onClose
// }) => {
//   useEffect(() => {
//     console.log('SpotCheck mount');

//     return () => {
//       console.log('SpotCheck unmount');
//     };
//   });

//   const props = useRef({

//   });

//   if (!window.lmfao)
//     return <tr><td>Spotcheck</td></tr>;

//   return (<>
//     <tr className={"k-master-row"}>
//       <td
//         style={{
//           verticalAlign: "top",
//           paddingLeft: 5,
//         }}
//         children={props.task.taskTemplate.name || null}
//       />
//       <td
//         style={{
//           verticalAlign: "top",
//           paddingLeft: 5,
//         }}
//         children={props.task.taskTemplate.description || null}
//       />
//       <td
//         style={{
//           verticalAlign: "top",
//           textAlign: "right",
//           paddingLeft: 5,
//         }}
//       >
//         <Button
//           type="button"
//           // id={"Edit" + this.props.sequence}
//           style={{
//             width: "28px",
//             height: "28px",
//             borderRadius: "25% 25%",
//             marginTop: "2px",
//             marginBottom: "2px",
//           }}
//           className="buttons-container-button"
//           icon="edit"
//           disabled={props.isDeleteMode}
//           onClick={editSpotCheck}
//         />
//       </td>
//     </tr>
//     {this.state.showSpotCheck && (
//       <tr
//         // id={"spotCheck_" + sequence}
//         className={"k-master-row"}
//       >
//         <td colSpan="2" align={"left"}>
//           <table
//             border="0"
//             cellPadding={"0"}
//             cellSpacing={"0"}
//             width={"100%"}
//           >
//             <tbody>
//               <tr>
//                 <td width={"25%"} align="center">
//                   <label>
//                     <b>LSL</b>
//                   </label>
//                 </td>
//                 <td width={"25%"} align="center">
//                   <label>
//                     <b>Target</b>
//                   </label>
//                 </td>
//                 <td width={"25%"} align="center">
//                   <label>
//                     <b>USL</b>
//                   </label>
//                 </td>
//                 <td width={"25%"} align="center">
//                   <label>
//                     <b>Type</b>
//                   </label>
//                 </td>
//               </tr>
//               <tr>
//                 <td width={"25%"} align="left">
//                   <input
//                     type="input"
//                     readOnly={true}
//                     key={"lsl_" + sequence}
//                     // id={"lsl_" + sequence}
//                     name={"lsl_" + sequence}
//                     value={this.state.lsl}
//                     style={{
//                       width: "90%",
//                       lineHeight: "32px",
//                       textAlign: "center",
//                       marginBottom: "10px",
//                       marginTop: "10px",
//                     }}
//                   />
//                 </td>
//                 <td width={"25%"} align="left">
//                   <input
//                     type="input"
//                     key={"target_" + sequence}
//                     // id={"target_" + sequence}
//                     name={"target_" + sequence}
//                     value={this.state.target}
//                     readOnly={true}
//                     style={{
//                       width: "90%",
//                       lineHeight: "32px",
//                       textAlign: "center",
//                       marginBottom: "10px",
//                       marginTop: "10px",
//                     }}
//                   />
//                 </td>
//                 <td width={"25%"} align="left">
//                   <input
//                     type="input"
//                     key={"usl_" + sequence}
//                     // id={"usl_" + sequence}
//                     name={"usl_" + sequence}
//                     value={this.state.usl}
//                     readOnly={true}
//                     style={{
//                       width: "90%",
//                       lineHeight: "32px",
//                       textAlign: "center",
//                       marginBottom: "10px",
//                       marginTop: "10px",
//                     }}
//                   />
//                 </td>
//                 <td width={"25%"}>
//                   <input
//                     type="input"
//                     key={"type_" + sequence}
//                     // id={"type_" + sequence}
//                     name={"type_" + sequence}
//                     defaultValue={this.state.type.name}
//                     readOnly={true}
//                     style={{
//                       textAlign: "center",
//                       width: "90%",
//                       lineHeight: "32px",
//                       marginBottom: "10px",
//                       marginTop: "10px",
//                     }}
//                   />
//                 </td>
//               </tr>
//               <tr>
//                 <td align="center">
//                   <label>
//                     <b>Actual °C</b>
//                   </label>
//                 </td>
//                 <td align="center">
//                   <label>
//                     <b>Serial No.</b>
//                   </label>
//                 </td>
//                 <td colSpan={"2"}>
//                   <table
//                     border={"0"}
//                     cellPadding={"0"}
//                     cellSpacing={"0"}
//                     width={"100%"}>
//                     <td align="center" width="25%">
//                       {this.state.switchOn
//                         ? <b>on</b>
//                         : <b>off</b>
//                       }
//                     </td>
//                     <td align="center" width="25%">
//                       <label>
//                         <b>P/F</b>
//                       </label>
//                     </td>
//                     <td width="50%" align="center">
//                       <label>
//                         <b>Corrective Action</b>
//                       </label>
//                     </td>
//                   </table>
//                 </td>
//               </tr>
//               <tr>
//                 <td align="left">
//                   <Field
//                     ref={this.myRef}
//                     key={"temperature_" + sequence}
//                     type={"text"}
//                     // id={"temperature_" + sequence}
//                     name={"temperature_" + sequence}
//                     component={InputText}
//                     defaultValue={this.state.temperature}
//                     onChange={this.temperatureChange}
//                     disabled={disableTemperatureTypeIn}
//                     style={{
//                       width: "90%",
//                       lineHeight: "32px",
//                       textAlign: "center",
//                       marginBottom: "10px",
//                       marginTop: "10px",
//                     }}
//                   />{" "}
//                 </td>
//                 <td align="left">
//                   <Field
//                     style={{ width: "90%", float: "left" }}
//                     component={DropDownList}
//                     defaultValue={
//                       this.state.serialNumbers.length == 0
//                         ? undefined
//                         : this.state.serialNumbers[0]
//                     }
//                     onChange={this.dropDownChange}
//                     data={this.state.serialNumbers}
//                   />{" "}
//                 </td>
//                 <td colSpan={"2"}>
//                   <table
//                     border={"0"}
//                     cellPadding={"0"}
//                     cellSpacing={"0"}
//                     width={"100%"}>
//                     <tbody>
//                       <tr>
//                         <td align="center" valign="middle" width="25%">
//                           <Field
//                             // component={Switch}
//                             component={(fieldProps) => (
//                               <Switch
//                                 {...fieldProps} // ✅ spread all field props
//                                 checked={this.state.switchOn} // ✅ controlled manually
//                                 disabled={!this.state.switchStatus}
//                                 onChange={(e) => {
//                                   this.setState({
//                                     switchOn: e.target.value
//                                   });
//                                   fieldProps.onChange?.({ value: e.value }); // ✅ sync to form
//                                 }}
//                               />
//                             )}
//                             onChange={this.switchToggle}
//                           />
//                         </td>
//                         <td align="center" width="25%">
//                           {this.state.status == 0 && (
//                             <div
//                               style={{
//                                 position: "relative",
//                                 marginTop: "2px",
//                                 width: "80px",
//                                 height: "36px",
//                                 border: "solid 2px #000000",
//                                 borderRadius: "5px 5px 5px 5px",
//                                 WebkitBorderRadius: "5px 5px 5px 5px",
//                                 MozBorderRadius: "5px 5px 5px 5px"
//                               }}
//                             >
//                               <span
//                                 style={{
//                                   position: "absolute",
//                                   top: "5px",
//                                   left: "20px",
//                                   color: "#000000"
//                                 }}
//                               ><b>&nbsp;</b></span>
//                             </div>
//                           )}
//                           {this.state.status == 1 && (
//                             <div
//                               style={{
//                                 position: "relative",
//                                 marginTop: "2px",
//                                 width: "80px",
//                                 height: "36px",
//                                 backgroundColor: "#ff6347",
//                                 border: "solid 2px #000000",
//                                 borderRadius: "5px 5px 5px 5px",
//                                 WebkitBorderRadius: "5px 5px 5px 5px",
//                                 MozBorderRadius: "5px 5px 5px 5px"
//                               }}
//                             >
//                               <span
//                                 style={{
//                                   position: "absolute",
//                                   top: "5px",
//                                   left: "20px",
//                                   color: "#ffffff"
//                                 }}
//                               ><b>FAIL</b></span>
//                             </div>
//                           )}
//                           {this.state.status == 2 && (
//                             <div
//                               style={{
//                                 position: "relative",
//                                 marginTop: "2px",
//                                 width: "80px",
//                                 height: "36px",
//                                 backgroundColor: "#009900",
//                                 border: "solid 2px #000000",
//                                 borderRadius: "5px 5px 5px 5px",
//                                 WebkitBorderRadius: "5px 5px 5px 5px",
//                                 MozBorderRadius: "5px 5px 5px 5px"
//                               }}
//                             >
//                               <span
//                                 style={{
//                                   position: "absolute",
//                                   top: "5px",
//                                   left: "20px",
//                                   color: "#ffffff"
//                                 }}
//                               ><b>PASS</b></span>
//                             </div>
//                           )}
//                         </td>
//                         <td width="50%" valign="middle">
//                           <Field
//                             key={"action_" + sequence}
//                             // id={"action_" + sequence}
//                             name={"action_" + sequence}
//                             component={Input}
//                             defaultValue={this.state.action}
//                             onChange={this.actionChange}
//                             style={{
//                               textAlign: "center",
//                               width: "90%",
//                               lineHeight: "32px",
//                               margin: "0px",
//                               padding: "0px"
//                             }}
//                           />{" "}
//                         </td>
//                       </tr>
//                     </tbody>
//                   </table>
//                 </td>
//               </tr>
//             </tbody>
//           </table>
//         </td>
//         <td>&nbsp;</td>
//       </tr>
//     )}
//   </>);
// };
